import { NumberInput, useRecordContext } from 'react-admin';
import { useSearchParams } from 'react-router-dom';

interface Props {
  source: string;
  label?: string;
  required?: boolean;
}

export const validateAmount =
  (type: string | null) =>
  (value: number): string | undefined => {
    if (typeof value === 'number' && type === 'credit' && value <= 0) {
      return 'Zadajte sumu príjmu ako kladné číslo';
    }
    if (typeof value === 'number' && type === 'debit' && value >= 0) {
      return 'Zadajte sumu výdavku ako kladné číslo';
    }
    return undefined;
  };

export const CashFlowAdjustmentAmountInput: React.FC<Props> = ({ label, required, source }) => {
  const record = useRecordContext();
  const [searchParams] = useSearchParams();
  const type = record?.period?.expectedAmount?.amount
    ? record?.period?.expectedAmount?.amount < 0
      ? 'debit'
      : 'credit'
    : searchParams.get('type');

  return (
    <NumberInput
      format={(value) => (typeof value === 'number' ? (type === 'debit' ? -value : value) : undefined)}
      label={label}
      parse={(value) => (typeof value === 'number' ? (type === 'debit' ? -value : value) : undefined)}
      required={required}
      source={source}
      validate={validateAmount(type)}
    />
  );
};
